export const SET_FLOAT = 'SET_USER_FLOAT'
export const SET_FLOAT_INCREASE = 'SET_FLOAT_INCREASE'